import { UndefinedInitialDataOptions, useQuery } from '@tanstack/react-query'
import { getNftsForOwners } from '../api-clients/alchemy'
import useActiveOrDefaultChain from '../hooks/web3/useActiveOrDefaultChain'

type NftContractMetadataQueryOptions = Omit<
  UndefinedInitialDataOptions<Awaited<ReturnType<typeof getNftsForOwners>>>,
  'queryFn' | 'queryKey'
>

const useNftsForOwner = (
  account: string | undefined,
  contractAddress: string[] | undefined,
  options?: NftContractMetadataQueryOptions
) => {
  const chain = useActiveOrDefaultChain()

  const { enabled, ...rest } = options ?? {}

  return useQuery({
    queryFn: () => getNftsForOwners(account, contractAddress, chain.id),
    enabled: Boolean(account && contractAddress) && enabled,
    queryKey: ['getNftsForOwners', account, contractAddress?.sort().join('')],
    ...rest,
  })
}

export default useNftsForOwner
